import { IBuildingUtilities } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { convertQueryCommandToQueryString, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IObjectWithTranslations } from '@/shared';
import { adminRequest } from '@/shared/request-configs/admin-request';
import vm from '@/main';
import { getTranslationsByClientIdAndModel, saveTranslationsInObjects } from '@/shared/services/translations';
import { translationFormatter } from '@/shared/helpers/translation-formatter';
import { IStateStrict } from '@/shared/interfaces/store-base';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IFilterPayloadV2 } from '@/shared/interfaces/filter-payload-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/utilities';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  limit: 999,
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IBuildingUtilities>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,
  state: {
    ...base.state,
  },
  getters: {
    ...base.getters,
  },
  mutations: {
    ...base.mutations,
  },
  actions: {
    ...base.actions,
    get: async (ctx: ActionContext<IStateStrict<IBuildingUtilities>, any>, payload: IFilterPayloadV2) => {
      const utilitiesList = await adminRequest.get(`/property-api/utilities`, convertQueryCommandToQueryString({
        ...payload.filters,
        limit: 999,
      }));
      const app = vm();
      if (app && app?.$rsGlobals.$siteSourceClientLanguages?.length > 0) {
        const translations = await getTranslationsByClientIdAndModel(app.$rsGlobals.$currentClient.id!, 'building_utilities');
        utilitiesList.data = translationFormatter(
          utilitiesList.data,
          translations,
          app?.$rsGlobals.$siteSourceClientLanguages,
          {
            clientId: app.$rsGlobals.$currentClient.id!,
            model: 'building_utilities',
            keys: ['name'],
          },
        );
      }
      ctx.commit('set', utilitiesList);
    },
    saveTranslations: async (ctx: ActionContext<IStateStrict<IBuildingUtilities>, any>, data: IObjectWithTranslations<IBuildingUtilities>[]) => {
      const result = await saveTranslationsInObjects(data, 'building_utilities');
      ctx.commit('set', { ...ctx.state.list, ...{ data: result } });
    },
  },
};
